import {ModalComponentProps, Block, Button, Card, Dialog, DialogBody, DialogFooter, VF} from '@mc/ui-v4';

import {Form} from 'react-final-form';
import React from 'react';
import {ShapefileMetadataVO, ShpImportApi} from '../../../api';
import {actionApiCall} from '@mc/react-app-v4';

type Props = ModalComponentProps & {onSubmit: (data: ShapefileMetadataVO) => void};

export const UploadShpModal: React.FC<Props> = ({onClose, onSubmit}) => {
    return (
        <Form onSubmit={onSubmit}>
            {({handleSubmit, submitting, form: {change}}) => {
                return (
                    <Dialog onClose={onClose} title={'Import vrstvy'}>
                        <DialogBody>
                            <Card>
                                <Block>
                                    <VF.File
                                        label="ZIP soubor"
                                        name="file"
                                        // @ts-ignore
                                        onUpload={async (file: File) =>
                                            await actionApiCall(async () => {
                                                const data = (await ShpImportApi.uploadShp(file)).data;
                                                change('layerName', data.layerName);
                                                change('attributes', data.attributes);
                                                change('filePath', data.filePath);
                                                handleSubmit();
                                            })
                                        }
                                    />
                                </Block>
                            </Card>
                        </DialogBody>
                        <DialogFooter>
                            <Button disabled={submitting} style={'link'} onClick={onClose}>
                                Zrušit
                            </Button>
                            <Button style={'primary'} disabled={submitting} onClick={handleSubmit}>
                                Pokračovat
                            </Button>
                        </DialogFooter>
                    </Dialog>
                );
            }}
        </Form>
    );
};
